<template>
  <div class="activityListInfo">
    <BannerSwiper :bannerData="bannerList" />
    <div class="CYT-detail-info">
      <div class="article-content">
        <div class="article">
          <div class="CYT-detail-title">
            {{
              lan
                ? exhibitionData.activityEnTitle
                : exhibitionData.activityCnTitle
            }}
          </div>
          <div class="CYT-sub-title">
            {{
              lan
                ? exhibitionData.activityEnSubTitle
                : exhibitionData.activityCnSubTitle
            }}
          </div>
          <div
            class="CYT-sub-title"
            v-if="exhibitionData.startDate"
          >
            {{ formatActivityDate(exhibitionData.startDate, exhibitionData.endDate) }}
          </div>
          <div class="detail-dec">
            <div
              class="html-show"
              v-html="lan ? exhibitionData.contentEn : exhibitionData.contentCn"
            ></div>
            <div class="share-box" v-if="!isIndex">
              <ShareQr
                :showApplet="false"
                :showHomeStay="false"
                :showLodg="false"
                :showQrCode="exhibitionData.wxQrCode"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShareQr from "../components/shareQr.vue";
import BannerSwiper from "../components/bannerSwiper.vue";

export default {
  name: "activityListInfo",
  components: {
    ShareQr,
    BannerSwiper,
  },
  data() {
    return {
      isIndex: false,
      content: "",
      pageIndex: 1,
      bannerList: [],
      exhibitionData: {},
      exhibitionList: [],
      lan: this.$store.state.isEn,
      isBackNavigation: false,
      pendingScrollPosition: null, // 存储待恢复的滚动位置
    };
  },
  watch: {
    pageIndex(val, oldval) {},
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
    },
  },
  // 使用 activated 钩子，适用于 keep-alive 组件
  activated() {
    // 只有在非返回操作时才恢复滚动位置
    if (!this.isBackNavigation) {
      this.restoreScrollPosition();
    } else {
      // 如果是返回操作，设置标记并在下一次 DOM 更新后恢复滚动
      this.isBackNavigation = false;
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
    
    // 监听页面可见性变化
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // 监听浏览器前进后退按钮
    window.addEventListener("popstate", this.handlePopState);
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    handleMediaQueryChange(event) {
      let screenWidth =
        window.innerWidth || document.documentElement.clientWidth;
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
        this.screenWidth = screenWidth;
      }
    },
    // 保存滚动位置
    saveScrollPosition() {
      // 保存当前页面的滚动位置
      const scrollPosition = {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop,
      };

      // 将滚动位置保存到 sessionStorage 中，使用当前路由作为 key
      const key = `scrollPosition_${this.$route.fullPath}`;
      sessionStorage.setItem(key, JSON.stringify(scrollPosition));
    },

    // 恢复滚动位置
    restoreScrollPosition() {
      // 使用当前路由作为 key 从 sessionStorage 中获取保存的滚动位置
      const key = `scrollPosition_${this.$route.fullPath}`;
      const savedPosition = sessionStorage.getItem(key);

      if (savedPosition) {
        try {
          const position = JSON.parse(savedPosition);
          // 检查数据是否已经加载完成
          if (this.exhibitionData && Object.keys(this.exhibitionData).length > 0) {
            // 如果数据已加载，直接执行滚动
            this.executeScroll(position);
          } else {
            // 如果数据未加载，先保存位置，等数据加载完成后再执行
            this.pendingScrollPosition = position;
          }
        } catch (e) {
          console.error("恢复滚动位置失败:", e);
        }
      }
    },

    // 执行滚动操作
    executeScroll(position) {
      this.$nextTick(() => {
        // 添加额外的延迟确保页面完全渲染
        setTimeout(() => {
          window.scrollTo({
            top: position.y,
            left: position.x,
            behavior: "auto",
          });
        }, 100);
      });
    },

    // 处理页面可见性变化
    handleVisibilityChange() {
      if (!document.hidden) {
        // 页面变为可见时恢复滚动位置
        this.restoreScrollPosition();
      }
    },

    // 处理浏览器前进后退按钮
    handlePopState(event) {
      this.isBackNavigation = true;
      // 在下一个事件循环中恢复滚动位置
      this.$nextTick(() => {
        setTimeout(() => {
          this.restoreScrollPosition();
        }, 100);
      });
    },
    getVideoKey() {
      return this.lan ? "videoEn" : "videoCn";
    },
    // 替换中文双引号为英文双引号
    replaceChineseQuotes(text) {
      if (!text) return text;
      // 处理HTML实体编码的中文双引号
      let result = text.replace(/&ldquo;/g, '"');
      result = result.replace(/&rdquo;/g, '"');
      // 处理直接的中文引号字符
      result = result.replace(/[“”‘’]/g, '"');
      return result;
    },

    // 格式化活动日期显示
    formatActivityDate(startDate, endDate) {
      // 如果没有结束日期或者开始日期和结束日期相同，则只显示开始日期
      if (!endDate || startDate === endDate) {
        return startDate || '';
      }
      // 否则显示日期范围格式
      return `${startDate || ''}-${endDate || ''}`;
    },
    init() {
      let id = this.$route.query.id;
      let activityType = this.$route.query.activityType;
      this.$api.get(
        "/activity/list",
        { current: 1, pageSize: 10, id: id, activityType: activityType },
        (r) => {
          const { data, code } = r;
          if (code == 0 && data.length > 0) {
            const videoKey = this.getVideoKey(); // 获取视频属性
            const exhibitionData = data[0];
            // 处理英文富文本内容中的中文双引号
            exhibitionData.contentEn = this.replaceChineseQuotes(exhibitionData.contentEn);
            this.exhibitionData = exhibitionData;
            if (data[0][videoKey]) {
              this.bannerList = [
                {
                  video: data[0][videoKey],
                },
                ...JSON.parse(data[0].image),
              ];
            } else {
              this.bannerList = JSON.parse(data[0].image);
            }
            this.bannerList.forEach((el, index) => {
              el.id = index + 1;
              el.img = el.src || "";
            });
            
            // 数据加载完成后，如果有待恢复的滚动位置，则执行恢复
            if (this.pendingScrollPosition) {
              this.$nextTick(() => {
                this.executeScroll(this.pendingScrollPosition);
                this.pendingScrollPosition = null;
              });
            }
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.content-title {
  margin-top: 20px;
}
.activityListInfo {
  margin-top: 94px;
  overflow: hidden;
}

.CYT-detail-info {
  position: relative;
  width: 1440px;
  height: 100%;
  margin: 70px auto 80px;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 100%;
  height: auto;
  padding-bottom: 50px;
}
.share-box {
  margin-top: 5px;
}
.CYT-detail-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.detail-sub-title {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 700;
}
.detail-dec {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 400;
}
.html-show {
  width: 80%;
}
.grey-line {
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}
.show-act-box {
  width: 100%;
  margin: 60px auto 90px;
}
.act-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.CYT-sub-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
.title-right::after {
  content: "";
  position: absolute;
  top: 55%;
  right: 0px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(45deg);
  transform: translateY(-45%) rotate(45deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
@media (max-width: 1440px) {
  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 70px auto 60px;
    background-color: #fff;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .article {
    width: 100%;
    height: auto;
    padding-bottom: 50px;
  }
}
@media (max-width: 960px) {
  .content-title {
    margin-top: 20px;
  }
  .activityListInfo {
    margin-top: 80px;
  }

  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 30px auto 20px;
    background-color: #fff;
  }
  .article-content {
    width: 90%;
  }
  .article {
    width: 100%;
    margin: 0 auto;
    height: auto;
    padding-bottom: 10px;
  }
  .detail-dec {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
    flex-direction: column;
  }
  .html-show {
    width: 100%;
  }
  .share-box {
    align-self: flex-end;
    margin-top: 20px;
  }
  .CYT-detail-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .detail-sub-title {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 700;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 50px auto 0;
    background: #d8d8d8;
  }
  .show-act-box {
    width: 100%;
    margin: 30px auto 30px;
  }
  .act-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
@media (max-width: 640px) {
  .CYT-detail-title {
    font-size: 18px;
  }
  .title-left {
    font-size: 22px;
    margin-left: 0%;
  }
  .CYT-sub-title {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .detail-sub-title {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .detail-dec {
    font-size: 13px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  .article {
    margin: 10px auto;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 30px auto 0;
    background: #d8d8d8;
  }
  .show-act-box {
    width: 100%;
    margin: 20px auto 0px;
  }
}
</style>